import saveAs from 'file-saver'

import { post, get } from '@/util/auth'

import { API_ROUTE_DOCUMENT } from './apiRoutes'

const documentResources = {
  authorizeFileDownload: async (documentId: number) => {
    const response = await get<{ body: string; filename: string }>(
      API_ROUTE_DOCUMENT + '/' + String(documentId)
    )
    saveAs(atob(response.body), response.filename)
    return { filename: response.filename }
  },

  // Mutations
  uploadAuthorization: async ({
    file,
    type,
    customerId,
  }: {
    file: File
    type: string
    customerId: number
  }) => {
    const base64EncodedFile = await getBase64(file)
    const parsedFile = transformFileForWS({ file, base64EncodedFile, type, customerId })

    const response = await post<{ id: number; filename: string }>(API_ROUTE_DOCUMENT, parsedFile)

    return response
  },
}

export default documentResources

const getBase64 = (file: File) =>
  new Promise<string | ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (reader.result) resolve(reader.result)
    }
    reader.onerror = error => reject(error)
  })

const transformFileForWS = ({
  file,
  base64EncodedFile,
  type,
  customerId,
}: {
  file: File
  base64EncodedFile: string | ArrayBuffer
  customerId: number
  type: string
}) => ({
  type,
  customer_id: customerId,
  filename: file.name,
  extension: file.name.split('.').pop()?.toUpperCase(),
  body: base64EncodedFile,
})
